import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentVersion: null
};

const editorJsonVersionSlice = createSlice({
  name: 'currentVersion',
  initialState,
  reducers: {
    loadCurrentVersion(state, action) {
      state.currentVersion = action.payload;
    }
  },
});

export const { loadCurrentVersion } = editorJsonVersionSlice.actions;
export default editorJsonVersionSlice.reducer;
